import { SelectedRowsCount } from "components/BaseTableV3/SelectedRowsCount";
import useCaseMapStore from "stores/useCaseMapStore";
import { MachineApprovalSelect } from "./MachineApprovalSelect";

export function CaseMapBulkBar() {
  const checkedMachineIds = useCaseMapStore(s => s.checkedMachineIds);
  const clearChecked = useCaseMapStore(s => s.clearChecked);

  if (!checkedMachineIds.length) return null;

  return (
    <div className="tw:flex tw:shrink-0 tw:items-center tw:gap-2">
      <SelectedRowsCount
        count={checkedMachineIds.length}
        onRemove={clearChecked}
      />
      <MachineApprovalSelect
        machineIds={checkedMachineIds}
        onDone={clearChecked}
      />
    </div>
  );
}
